<script setup>
import { ref } from 'vue'
import { useNotification } from "@kyvg/vue3-notification"
import FormSwitch from '../../components/Atoms/FormSwitch.vue'

const { notify } = useNotification()

const props = defineProps({
	stream: {
		type: Object,
		required: true,
		validator(v) {
			return Object.prototype.hasOwnProperty.call(v, '_id')
		}
	},
	settings: {
		type: Object,
		required: true,
	},
})

const emit = defineEmits({
	'on-update': () => true
})

const playbackFeatureKeys = ['responsive', 'autoPlayNext', 'autoPlay', 'loop', 'shuffle']

const featureProcessing = ref(
	Object.fromEntries(playbackFeatureKeys.map((key) => [key, false]))
)

const featureDisabled = ref(
	Object.fromEntries(playbackFeatureKeys.map((key) => [key, false]))
)

const saveSetting = async (key, status) => {
	featureProcessing.value[key] = true
	try {
		props.settings[key].status = status
		emit('on-update', { key, value: props.settings[key] })
	} catch (e) {
		notify({ group: 'error', text: 'Unable to save your changes.' })
	}
	featureProcessing.value[key] = false
	featureDisabled.value[key] = true
}

const toggleFeature = async (featureName) => {
	if (featureProcessing.value[featureName]) return
	const newValue = props.settings[featureName].status
	props.settings[featureName].status = newValue
	await saveSetting(featureName, newValue)
}

</script>

<template>
	<section class="bg-surface-2 !p-3 !rounded-lg !mb-4">
		<ul class="flex flex-col gap-2">
			<li class="bg-surface-3 !px-3 h-11 !rounded-lg flex items-center">
				<FormSwitch
					labelPosition="left"
					class="w-full justify-between"
					v-model="settings.autoPlayNext.status"
					@change="toggleFeature('autoPlayNext')"
					label="Autoplay next"
				/>
			</li>
			<li class="bg-surface-3 !px-3 h-11 !rounded-lg flex items-center">
				<FormSwitch
					labelPosition="left"
					class="w-full justify-between"
					v-model="settings.autoPlay.status"
					@change="toggleFeature('autoPlay')"
					label="Autoplay on load"
				/>
			</li>
			<li class="bg-surface-3 !px-3 h-11 !rounded-lg flex items-center">
				<FormSwitch
					labelPosition="left"
					class="w-full justify-between"
					v-model="settings.loop.status"
					label="Loop playlist"
					@change="toggleFeature('loop')"
				/>
			</li>
			<li class="bg-surface-3 !px-3 h-11 !rounded-lg flex items-center">
				<FormSwitch
					labelPosition="left"
					class="w-full justify-between"
					v-model="settings.shuffle.status"
					label="Shuffle"
					@change="toggleFeature('shuffle')"
				/>
			</li>
		</ul>
	</section>
</template>
